import './courselIcons.css';

import ExpensibleStamp from '../../../../../assets/icons/expensibleStamp/expensibleStamp';
import Van from './icons/van/van';
import Truck from './icons/truck/truck';
import TowTruck from './icons/towTruck/towTruck';
import Roller from './icons/roller/roller';
import Manufacturing from './icons/manufacturing/manufacturing'
import Logging from './icons/logging/logging';
import Kat from './icons/kat/kat'
import ForkLift from './icons/forkLift/forkLift'

export default function CourouselIcons({carouselIndexIcon, isMobile}) {

    const iconList = [Van, Truck, TowTruck, Roller, Manufacturing, Logging, Kat, ForkLift];

    return(
        <div>
            {isMobile ?

            <div className="courousel-icons-bar courousel-icons-bar-mobile">
                {iconList.map((Icon, index) => (
                    <Icon key={index} activeIcon={index + 1 === carouselIndexIcon ? 'active-icon' : ''}/>
                ))}
            </div>

            :

            <div className="courousel-icons-bar"> 
                {iconList.map((Icon, index) => (
                    <Icon key={index} activeIcon={index + 1 === carouselIndexIcon ? 'active-icon' : ''}/>
                ))}
            </div>

            }
        </div>
    )
}